import { render, staticRenderFns } from "./BaseTeamCard.vue?vue&type=template&id=1101fb0f&scoped=true&"
import script from "./BaseTeamCard.vue?vue&type=script&lang=js&"
export * from "./BaseTeamCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1101fb0f",
  null
  
)

export default component.exports